import React from "react";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import {makeStyles,} from '@material-ui/core';

function Css(props) {
  const [buttonColor, setButtonColor] = useState("#bbcf74");

  const { reducer } = props;
  const storeInfo = props.sessionReducer?.store_details;

  // useEffect(() => {
  //   setButtonColor(storeInfo?.primary_color);
  // }, [storeInfo?.primary_color]);

  // console.log(buttonColor);
  // //     const storeDetail = localStorage.getItem("STORE_DETAILS");
  // //     let Store = null;
  // //     if (storeDetail) {
  // //       console.log(JSON.parse(storeDetail));
  // //       Store = JSON.parse(storeDetail);
  // //     }

  // //    const BUTTON_COLOR = (Store?.store?.primary_color) || "#bbcf74";


  const useStyles = makeStyles({
    searchInput: {
      background: '#eeeeee',
      borderRadius: '0.5rem',
      width: '95%',
      margin: '5px auto',
      display: 'flex',
    },
  });

  return <>




  </>;
}
const mapStateToProps = (state) => {
  return {
    reducer: state.customerReducer,
  };
};

export default connect(mapStateToProps)(Css);
